import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FullField from '../../../components/FormElements/FullField';
import Button from '../../../components/ui/Button';
import styles from '../../../theme/common.module.scss';

const recoverPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});

const RecoverPasswordForm = (props) => {
  const defaultData = {
    email: '',
  };
  const { onSubmit, serverError, loading } = props;
  return (
    <Formik initialValues={defaultData} validationSchema={recoverPasswordSchema} onSubmit={onSubmit}>
      {({ errors, touched, values }) => (
        <Form>
          <FullField label='Email' name='email' error={touched.email ? errors.email : null} value={values.email} />
          <Button type='submit' loading={loading}>
            Submit
          </Button>
          {props.serverError ? <div className={styles.formError}>{serverError}</div> : null}
        </Form>
      )}
    </Formik>
  );
};

export default RecoverPasswordForm;
